'use strict';
angular.module('liveChatSnapInModule', [])
    .config(function livechatSnapinConfig($routeProvider){
        if(TRPCONFIG.Domain.LiveChat && TRPCONFIG.Domain.LiveChat.SnapInEnabled) {
            const cookies = document.cookie + '';
            $routeProvider.when('/livechatredirect', {
                template: '',
                controller: ['cookieService', function(cookieService) {
                    let redirectUrl = _.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.RedirectUrl');
                    let cookieName = _.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.cookieName', 'key');
                    let cookie = cookieService.get(cookieName, cookies);
                    window.location.href = `${redirectUrl}${cookie}`;
                }]
            });
        }
    })
    .run(['liveChatSnapInService', liveChatSnapInService => {
        TRPCONFIG.Domain.LiveChat
        && TRPCONFIG.Domain.LiveChat.SnapInEnabled
        && liveChatSnapInService.initialise();
    }]);
